import React, { Component } from 'react';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';

import Layout from '../Layout';

import UserForm from '../../containers/UserForm';

const styles = theme => ({
    card: {
      display: 'flex',
      boxShadow: 'none',
    },
    content: {
      flex: '1 0 auto',
    },
    paperStyle: {
        width: '70%',
        height: '70%',
        display: 'inline-block',
        margin: 20,
        marginTop: '13vh'
    },
    headerStyle: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
    },
    headerTitleStyle: {
        flexDirection: 'column',
        margin: '2%',
        fontSize: '24px',
        fontFamily: 'Roboto'
    }
});

class AccountSettings extends Component {

    handleSave = (event) => {
      // const parsed = queryString.parse(this.props.location.search);
      // this.props.data.resetPassword(parsed.username, event.oldPassword, event.newPassword);
    }

    render() {
        const { classes } = this.props;
        return (
        <Layout className="App" showMenu menuTitle="Account Settings" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.">
            <Paper className={classes.paperStyle}>
                <AppBar position="static" className={classes.headerStyle}>
                    <Toolbar className={classes.headerTitleStyle}>
                        <Typography variant="title">
                          Account Settings
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Card className={classes.card}>
                    <CardContent className={classes.content}>
                        <UserForm />
                    </CardContent>
                </Card>
            </Paper>
        </Layout>);
    }
}

AccountSettings.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles, { withTheme: true })(AccountSettings);


// WEBPACK FOOTER //
// ./src/components/Account/AccountSettings.js